/**
 * Sorted list of `<symbol id="…">` values in `libs/angular-cads/src/assets/symbol-defs.svg`.
 * Regenerate when the sprite changes.
 */
export const CADS_SYMBOL_IDS = [
  'actions',
  'activate-card',
  'add',
  'alarm',
  'alert',
  'antenna',
  'arrow_down',
  'arrow_left',
  'arrow_right',
  'arrow_up',
  'autosave',
  'avatar',
  'bank',
  'bank-circle',
  'bike',
  'bill',
  'bluelock',
  'brightside-logo',
  'broken-link',
  'calendar',
  'calendar_check',
  'camera',
  'car',
  'car_2',
  'chat',
  'chat_double',
  'check',
  'check_badge',
  'checkbox-checked',
  'checkbox-unchecked',
  'checkmark',
  'chevron_down',
  'chevron_left',
  'chevron_right',
  'chevron_up',
  'circle_arrow',
  'circle_check',
  'circle_check_filled',
  'clear',
  'clock',
  'close',
  'cog',
  'copy',
  'credit_card',
  'doc_download',
  'document',
  'ellipses',
  'email',
  'fi-icon',
  'gauge',
  'grad_cap',
  'graph_positive',
  'grayinfo',
  'group',
  'headset',
  'help_ring',
  'home',
  'hour-glass',
  'icon-actions',
  'icon-bell',
  'icon-circle-check',
  'icon-eye-outline',
  'information',
  'invite',
  'key',
  'lightbulb',
  'lightning_bolt',
  'link',
  'location',
  'location_add',
  'lock',
  'lock_key',
  'lock_key_unlocked',
  'megaphone',
  'menu',
  'minus',
  'money_bag',
  'money_bag_in_hand',
  'notifications',
  'notifications_off',
  'paper_airplane',
  'paperclip',
  'pay-day',
  'pen',
  'phone',
  'pig',
  'pin',
  'plane',
  'plane_2',
  'plant_pot',
  'red-alert',
  'refresh',
  'restart',
  'rocket',
  'safe',
  'search',
  'secure',
  'send',
  'settings',
  'share',
  'shield-w-check',
  'shipping',
  'shopping_cart',
  'sign_out',
  'spinner',
  'star_shield',
  'suitcase',
  'timer-clocks',
  'toggle-off',
  'toggle-off-compact',
  'toggle-on',
  'toggle-on-compact',
  'transfer',
  'trash',
  'unlocked',
  'upload',
  'upload_cloud',
  'user',
  'user_chat_bubble',
  'view',
  'walking',
] as const;

/** Union of known sprite symbol ids shipped with CADS. */
export type CadsSymbolId = (typeof CADS_SYMBOL_IDS)[number];
